<template>
  <vue-splash
    :show="true"
    :logo="logo"
    title=""
    color="#009688"
    :size="400"
    :fixed="true"
  />
</template>

<script>
import YourLogo from "../assets/activation2.svg";

export default {
  name: "YourMagnificentVueComponent",
  computed: {
    logo() {
      return YourLogo;
    },
  },
};
</script>
